import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'calculadora',
    loadComponent: () =>
      import('./components/calculadora/calculadora.component').then(m => m.CalculadoraComponent),
    data: {
      breadcrumb: {
        label: 'Calculadora'
      }
    },
    children: [
      {
        path: 'simulador-regime-geral',
        loadComponent: () =>
          import('./components/simulador-calculo/simulador-calculo.component').then(m => m.SimuladorCalculoComponent),
        data: {
          breadcrumb: {
            label: 'Regime Regular'
          }
        },
      },
      {
        path: 'simulador-calculo',
        loadComponent: () =>
          import('./components/simulador-simples-nacional/simulador-simples-nacional.component').then(m => m.SimuladorSimplesNacionalComponent),
        data: {
          breadcrumb: {
            label: 'Regime Regular e Simples Nacional'
          }
        },
      },
      {
        path: 'pedagio',
        loadComponent: () =>
          import('./components/simulador-calculo-pedagio/simulador-calculo-pedagio.component').then(m => m.SimuladorCalculoPedagioComponent),
        data: {
          breadcrumb: {
            label: 'Pedágio'
          }
        },
      },
      {
        path: 'simplificado',
        loadComponent: () =>
          import('./components/simulador-split-payment-simplificado/simulador-split-payment-simplificado.component').then(m => m.SimuladorSplitPaymentSimplificadoComponent),
        data: {
          breadcrumb: {
            label: 'Simplificado'
          }
        },
      },
      {
        path: 'bases-de-calculo',
        loadComponent: () =>
          import('./components/simulador-base-calculo/simulador-base-calculo.component').then(m => m.SimuladorBaseCalculoComponent),
        data: {
          breadcrumb: {
            label: 'Bases de Cálculo'
          }
        },
      },
      // Rotas das bases de cálculo unificadas (NF-e/NFC-e e NFS-e):
      // acessíveis em qualquer ambiente VIA URL, deliberadamente FORA do menu.
      {
        path: 'base-calculo-unificada-nfe-nfce',
        loadComponent: () =>
          import('./components/simulador-base-calculo-unificada-nfe-nfce/simulador-base-calculo-unificada-nfe-nfce.component').then(m => m.SimuladorBaseCalculoUnificadaNfeNfceComponent),
        data: {
          breadcrumb: {
            label: 'Base de Cálculo Unificada — NF-e/NFC-e'
          }
        },
      },
      {
        path: 'base-calculo-unificada-nfse',
        loadComponent: () =>
          import('./components/simulador-base-calculo-unificada-nfse/simulador-base-calculo-unificada-nfse.component').then(m => m.SimuladorBaseCalculoUnificadaNfseComponent),
        data: {
          breadcrumb: {
            label: 'Base de Cálculo Unificada — NFS-e'
          }
        },
      },
      {
        path: 'assistente-busca-semantica',
        loadComponent: () =>
          import('./components/assistente-busca-semantica/assistente-busca-semantica.component').then(m => m.AssistenteBuscaSemanticaComponent),
        data: {
          breadcrumb: {
            label: 'Assistente de Busca Semântica'
          }
        },
      },
      {
        path: 'validador-xml',
        loadComponent: () =>
          import('./components/validador-xml/validador-xml.component').then(m => m.ValidadorXmlComponent),
        data: {
          breadcrumb: {
            label: 'Assistente de Validação'
          }
        },
      },
      {
        path: 'fundamentacoes-legais',
        loadComponent: () =>
          import('./components/consultar-fundamentacoes/consultar-fundamentacoes.component').then(m => m.ConsultarFundamentacoesComponent),
        data: {
          breadcrumb: {
            label: 'Fundamentações Legais'
          }
        },
      },
      {
        path: 'classificacoes-tributarias',
        loadComponent: () =>
          import('./components/consultar-classificacoes-tributarias/consultar-classificacoes-tributarias.component').then(m => m.ConsultarClassificacoesTributariasComponent),
        data: {
          breadcrumb: {
            label: 'Classificações Tributárias'
          }
        },
      },
      {
        path: 'aliquotas',
        loadComponent: () =>
          import('./components/consultar-aliquotas/consultar-aliquotas.component').then(m => m.ConsultarAliquotasComponent),
        data: {
          breadcrumb: {
            label: 'Alíquotas'
          }
        },
      },
      {
        path: 'nomenclaturas',
        loadComponent: () =>
          import('./components/consultar-ncm-nbs/consultar-ncm-nbs.component').then(m => m.ConsultarNcmNbsComponent),
        data: {
          breadcrumb: {
            label: 'Nomenclaturas (NCM e NBS)'
          }
        },
      },
      {
        path: 'compras-governamentais',
        loadComponent: () =>
          import('./components/consultar-compras-governamentais/consultar-compras-governamentais.component').then(m => m.ConsultarComprasGovernamentaisComponent),
        data: {
          breadcrumb: {
            label: 'Compras Governamentais'
          }
        },
      },
      {
        path: 'documentacao',
        loadComponent: () =>
          import('./components/documentacao/documentacao.component').then(m => m.DocumentacaoComponent),
        data: {
          breadcrumb: {
            label: 'Documentação da API de Integração'
          }
        },
        children: [
          {
            path: 'guia-integracao',
            loadComponent: () =>
              import('./components/documentacao/guia-integracao/guia-integracao.component').then(m => m.GuiaIntegracaoComponent),
            data: {
              breadcrumb: {
                label: 'Guia de Integração com ERP'
              }
            },
          }
        ]
      },
      {
        path: 'calculadora-offline',
        loadComponent: () =>
          import('./components/calculadora-offline/calculadora-offline.component').then(m => m.CalculadoraOfflineComponent),
        data: {
          breadcrumb: {
            label: 'Calculadora Offline'
          }
        },
        children: [
          {
            path: 'calculadora-offline-instrucoes',
            loadComponent: () =>
              import('./components/calculadora-offline/calculadora-offline-instrucoes/calculadora-offline-instrucoes.component').then(m => m.CalculadoraOfflineInstrucoesComponent),
            data: {
              breadcrumb: {
                label: 'Instruções de Instalação'
              }
            },
          }
        ]
      },
    ]
  },

  { path: '', redirectTo: 'calculadora', pathMatch: 'full' },
  {
    path: '**',
    loadComponent: () =>
      import('./components/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
    data: {
      breadcrumb: 'Página não encontrada'
    }
  },
];